import { useEffect, useRef, useState } from 'react';

const stats = [
  { icon: 'ri-book-open-line', value: 20000, suffix: '+', label: '海量漫画资源' },
  { icon: 'ri-user-smile-line', value: 500, suffix: '万+', label: '活跃读者' },
  { icon: 'ri-timer-flash-line', value: 99, suffix: '%', label: '更新及时率' },
  { icon: 'ri-shield-check-line', value: 100, suffix: '%', label: '正版授权' },
];

export default function StatsSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 },
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-14 md:py-20 bg-accent-500">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center text-white">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-white/20 flex items-center justify-center">
                <i className={`${stat.icon} text-xl w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-heading font-bold mb-1">
                {visible ? (
                  <CountUp target={stat.value} suffix={stat.suffix} />
                ) : (
                  <span>0{stat.suffix}</span>
                )}
              </div>
              <p className="text-sm text-white/80">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CountUp({ target, suffix }: { target: number; suffix: string }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (target <= 0) return;
    const duration = 2000;
    const steps = 60;
    const increment = target / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, duration / steps);
    return () => clearInterval(timer);
  }, [target]);

  return <span>{count}{suffix}</span>;
}